import './style.sass';

import parse from 'html-react-parser';
import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonUsualText from '../../../common-components/common-usual-text';
import CommonTitle from '../../../common-components/common-title';
import CommonSmallTitle from '../../../common-components/common-small-title';
import CommonSmallText from '../../../common-components/common-small-text';
import CommonCollapseItem from '../../../common-components/common-collapse-item';
import Link from 'next/link';

let list = [
    {
        img: '/images/svg/converter/converter-complex__item-img1.svg',
        title: '01. MVP',
        titleMobile: 'MVP',
        subtitle:
            'Прежде чем запустить проект, мы&nbsp;собрали MVP. Это был сайт на&nbsp;одном сервере с&nbsp;простыми формами конвертации. Он&nbsp;сразу был на&nbsp;8&nbsp;языках и&nbsp;с&nbsp;большим количеством форматов. Нам нужно было понять, как быстро страницы будут входить в&nbsp;топ выдачи Google и&nbsp;какая реальная конкуренция в&nbsp;выдаче, чтобы спрогнозировать динамику по&nbsp;трафику. MVP собрали за&nbsp;2&nbsp;месяца и&nbsp;быстро запустили проект.',
        reverse: false,
    },
    {
        img: '/images/svg/converter/converter-complex__item-img2.svg',
        title: '02. Подтверждение гипотезы',
        titleMobile: 'Подтверждение гипотезы',
        subtitle:
            'Решение сделать проект мультиязычным еще на&nbsp;уровне MVP было не&nbsp;случайным. Мы&nbsp;понимали, что сразу войти в&nbsp;топ по&nbsp;англоязычным странам будет нереально из-за большой конкуренции, поэтому в&nbsp;качестве одного языка выбрали вьетнамский. Мы&nbsp;увидели большой потенциал спроса при наличии всего 2-х языковых конкурентов. Ставка себя оправдала, и&nbsp;уже через 2&nbsp;месяца мы&nbsp;вошли в&nbsp;топ почти по&nbsp;всему семантическому ядру и&nbsp;получили много локального трафика. Это подтвердило нашу гипотезу о&nbsp;потенциале ниши и&nbsp;дало возможность получить поведенческий трафик, который повлиял на&nbsp;успех проектов в&nbsp;других языковых локациях.',
        reverse: true,
    },
    {
        img: '/images/svg/converter/converter-complex__item-img3.svg',
        title: '03. Growth Hacking',
        titleMobile: 'Growth Hacking',
        subtitle:
            'При дальнейшей работе с&nbsp;проектом мы&nbsp;активно применяли методологию <a class="converter__link" target="_blank" rel="noopener noreferrer nofollow" href="https://vc.ru/marketing/591060-growth-hacking-kak-vzlomat-marketing-i-prodazhi-v-usloviyah-krizisa">Growth Hacking</a>  в&nbsp;SEO. У&nbsp;нас есть бэклог гипотез по&nbsp;разным направлениям: новый функционал, интерфейс, линкбилдинг и&nbsp;юзабилити. Эти гипотезы проранжированы по&nbsp;степени нашей веры, потенциального эффекта и&nbsp;сложности реализации. В&nbsp;еженедельном режиме мы&nbsp;доставали из&nbsp;бэкглока и&nbsp;тестировали&nbsp;их. Успешные масштабировали, неуспешные отбрасывали. Такой подход в&nbsp;итоге и&nbsp;показал кратный рост трафика.',
        reverse: false,
    },
    {
        img: '/images/svg/converter/converter-complex__item-img4.svg',
        title: '04. Масштабирование',
        titleMobile: 'Масштабирование',
        subtitle:
            'После того, как мы&nbsp;подтвердили успешность ниши, стало понятно, что технологическое решение, которое было у&nbsp;нас на&nbsp;уровне MVP, нужно менять. Изначально оно проектировалось на&nbsp;трафик около 10&nbsp;тыс. посещений в&nbsp;сутки. Поэтому мы&nbsp;начали проектировать и&nbsp;реализовывать масштабируемое веб-приложение, которое могло&nbsp;бы выдержать до&nbsp;200&nbsp;тыс. пользователей в&nbsp;сутки, как и&nbsp;лидеры в&nbsp;этой нише. Здесь и&nbsp;пригодился наш технологический трамплин.',
        reverse: true,
    },
];

const Process = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
            <FullWrapper caseName="converter-process">
                <CommonTitle>Процессы</CommonTitle>

                <CommonUsualText className="converter-process__title">
                    Процесс управления продуктом отличается от&nbsp;разработки на&nbsp;заказ.
                    Но&nbsp;мы&nbsp;хорошо научились применять методологии успешного управления
                    стартапами в&nbsp;работе с&nbsp;основным институтами развития страны, такими
                    как:{' '}
                    <Link className="converter__link" href="/cases/development/gens">
                        РВК
                    </Link>
                    ,{' '}
                    <Link className="converter__link" href="/cases/marketing/skolkovo">
                        Сколково
                    </Link>
                    ,{' '}
                    <Link className="converter__link" href="/cases/marketing/rec">
                        Российский Экспортный Центр
                    </Link>
                    . Этот опыт позволил нам выстроить собственную эффективную систему запуска
                    продукта:
                </CommonUsualText>

                <div className="converter-process__container">
                    {list.map(({ img, title, subtitle, reverse }, index) => (
                        <ScrollAnimation
                            key={index}
                            animateIn="fadeInUp"
                            offset={100}
                            animateOnce={true}
                            duration={1}
                            className={
                                reverse
                                    ? 'converter-process__item converter-process__item--reverse'
                                    : 'converter-process__item'
                            }
                        >
                            <div className="converter-process__item-img">
                                <img src={img} alt="" loading="lazy" />
                            </div>
                            <div className="converter-process__item-info">
                                <CommonSmallTitle className="converter-process__item-title">
                                    {parse(title)}
                                </CommonSmallTitle>
                                <CommonSmallText className="converter-process__item-text">
                                    {parse(subtitle)}
                                </CommonSmallText>
                            </div>
                        </ScrollAnimation>
                    ))}
                </div>

                <div className="converter-process__container--mobile">
                    {list.map(({ titleMobile, subtitle }, index) => (
                        <CommonCollapseItem
                            key={index}
                            index={++index}
                            triggerText={titleMobile}
                            content={parse(subtitle)}
                            classParent={
                                'converter-process__collapse-item converter-complex__collapse-item'
                            }
                            numberColor={'#139cd9'}
                        />
                    ))}
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Process;
